var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white border border-gray-300 rounded-lg"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }